import React, {Component} from 'react';

import countries from '../../constants/countries.json';

import {dt, getCode} from 'l10n';

export default function CountrySelect(props) {
    let localeCode = getCode();

    let {name, onChange, defaultValue} = props;

    return (
        <select name={name} onChange={onChange} defaultValue={defaultValue}>
            <option value="">{dt('location_select', 'All')}</option>
            {countries.map((country) => <option value={country.code} key={country.code}>{country[localeCode]}</option>)}
        </select>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/CountrySelect.js